import { render } from "./CtaOverlayComponent.vue?vue&type=template&id=74d8844e&scoped=true&ts=true"
import script from "./CtaOverlayComponent.vue?vue&type=script&lang=ts"
export * from "./CtaOverlayComponent.vue?vue&type=script&lang=ts"

import "./CtaOverlayComponent.vue?vue&type=style&index=0&id=74d8844e&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d8844e"]])

export default __exports__